import { useData } from '@/contexts/data';

export const useTerritories = () => {
  const { territories, territoriesLoading, territoriesError } = useData();
  return {
    territories,
    total: territories.length,
    loading: territoriesLoading,
    error: territoriesError,
    refetch: () => {},
  };
};
